<div class="row">
  <div class="col-12 text-center">
    <div class="pt-4">
      You will be redirected to external page
    </div>
  </div>
</div>
